import {
    CLUSTER_LIST_REQUEST,
    CLUSTER_LIST_RESPONSE,
    CLUSTER_LIST_SEARCH_REQUEST,
    CLUSTER_LIST_CACHED_RESPONSE,
    CLUSTER_LIST_ERROR_RESPONSE,
    CLUSTER_ITEM_REQUEST,
    CLUSTER_ITEM_RESPONSE,
    CLUSTER_ITEM_CACHED_RESPONSE,
    CLUSTER_ITEM_ERROR_RESPONSE,
    CLUSTER_ITEM_SAVE_REQUEST,
    CLUSTER_ITEM_SAVE_RESPONSE,
    CLUSTER_ITEM_DELETE_REQUEST,
    CLUSTER_ITEM_DELETE_RESPONSE,
    CLUSTER_ITEM_DELETE_ERROR_RESPONSE,
    CLUSTER_SET_FILTER,
    CLUSTER_SET_EDIT_MODE,
    CLUSTER_UPDATE_FILTER_CRITERIA,
    CLUSTER_CLEAR_FILTER_CRITERIA,
    CLUSTER_APPLY_FILTER_CRITERIA,
    CLUSTER_UPDATE_IMAGE,
    CLUSTER_UPDATE_MODEL,
    CLUSTER_APPLY_MODEL_UPDATE,
    CLUSTER_CANCEL_MODEL_UPDATE,
    CLUSTER_ADD_NEW,
    CLUSTER_MODERATE,
    CLUSTER_ARTICLE_SEARCH_REQUEST,
    CLUSTER_ARTICLE_SEARCH_RESPONSE,
    CLUSTER_ARTICLE_EDIT_SELECT,
    CLUSTER_CONCEPTS_SEARCH_REQUEST,
    CLUSTER_CONCEPTS_SEARCH_RESPONSE,
    CLUSTER_TOPIC_EDIT_SELECT
} from "./action-types"

import {
    itemResponse,
    itemSaveRequest,
    itemDeleteRequest,
    itemDeleteResponse,
    itemCachedResponse,
    itemErrorResponse,
    itemDeleteErrorResponse
} from "./default-actions/entity-actions"

import {
    setFilter,
    listSearchRequest,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    setEditMode,
    defaultAction
} from "./default-actions/presentation-actions"

import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse,
    listInvalidationRequest
} from "./default-actions/paging-actions"

// Paging Actions
export const clusterListRequest = listRequest(CLUSTER_LIST_REQUEST)
export const clusterListSearchRequest = listSearchRequest(
    CLUSTER_LIST_SEARCH_REQUEST
)
export const clusterListInvalidationRequest = listInvalidationRequest(
    CLUSTER_LIST_REQUEST
)
export const clusterListResponse = listResponse(CLUSTER_LIST_RESPONSE)
export const clusterListCachedResponse = listCachedResponse(
    CLUSTER_LIST_CACHED_RESPONSE
)
export const clusterListErrorResponse = listErrorResponse(
    CLUSTER_LIST_ERROR_RESPONSE
)

// Entity Actions
export const clusterItemRequest = (
    id,
    isInvalidating,
    isFetchingAfterSave
) => ({
    type: CLUSTER_ITEM_REQUEST,
    id,
    isInvalidating: isInvalidating || false,
    isFetchingAfterSave: isFetchingAfterSave || false
})
export const clusterItemResponse = itemResponse(CLUSTER_ITEM_RESPONSE)
export const clusterItemCachedResponse = itemCachedResponse(
    CLUSTER_ITEM_CACHED_RESPONSE
)
export const clusterItemErrorResponse = itemErrorResponse(
    CLUSTER_ITEM_ERROR_RESPONSE
)
export const clusterItemSaveRequest = itemSaveRequest(CLUSTER_ITEM_SAVE_REQUEST)
export const clusterItemSaveResponse = itemResponse(CLUSTER_ITEM_SAVE_RESPONSE)
export const clusterItemDeleteRequest = itemDeleteRequest(
    CLUSTER_ITEM_DELETE_REQUEST
)
export const clusterItemDeleteResponse = itemDeleteResponse(
    CLUSTER_ITEM_DELETE_RESPONSE
)
export const clusterItemDeleteErrorResponse = itemDeleteErrorResponse(
    CLUSTER_ITEM_DELETE_ERROR_RESPONSE
)

// Presentation Actions
export const clusterSetFilter = setFilter(CLUSTER_SET_FILTER)
export const clusterSetEditMode = setEditMode(CLUSTER_SET_EDIT_MODE)
export const clusterUpdateFilterCriteria = updateFilterCriteria(
    CLUSTER_UPDATE_FILTER_CRITERIA
)
export const clusterClearFilterCriteria = clearFilterCriteria(
    CLUSTER_CLEAR_FILTER_CRITERIA
)
export const clusterApplyFilterCriteria = applyFilterCriteria(
    CLUSTER_APPLY_FILTER_CRITERIA
)
export const clusterUpdateModel = updateModel(CLUSTER_UPDATE_MODEL)
export const clusterUpdateImage = updateImage(CLUSTER_UPDATE_IMAGE)
export const clusterApplyModelUpdate = applyModelUpdate(
    CLUSTER_APPLY_MODEL_UPDATE
)
export const clusterCancelModelUpdate = cancelModelUpdate(
    CLUSTER_CANCEL_MODEL_UPDATE
)
export const clusterAddNew = defaultAction(CLUSTER_ADD_NEW)

export const clusterModerate = moderationStatus => ({
    type: CLUSTER_MODERATE,
    moderation: moderationStatus
})

export const clusterArticleSearchRequest = listSearchRequest(
    CLUSTER_ARTICLE_SEARCH_REQUEST
)
export const clusterArticleSearchResponse = listResponse(
    CLUSTER_ARTICLE_SEARCH_RESPONSE
)
export const clusterArticleEditSelect = (name, article) => ({
    type: CLUSTER_ARTICLE_EDIT_SELECT,
    name,
    article
})

export const clusterConceptSearchRequest = listSearchRequest(
    CLUSTER_CONCEPTS_SEARCH_REQUEST
)
export const clusterConceptSearchResponse = listResponse(
    CLUSTER_CONCEPTS_SEARCH_RESPONSE
)
export const clusterTopicEditSelect = (name, topic) => ({
    type: CLUSTER_TOPIC_EDIT_SELECT,
    name,
    topic
})
